module.exports = __webpack_public_path__ + "static/img/D1.9bf3308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/D1.png
// module id = PvWk
// module chunks = 1